import {useState} from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    InputAdornment,
    TextField,
    Typography
} from '@mui/material';
import {Search as SearchIcon} from '@mui/icons-material';

// Importiere die Quiz-Bilder
import exampleQuiz from '../../../img/quiz/example-quiz.jpg';
import deutschlandQuiz from '../../../img/quiz/deutschland-quiz.jpg';
import fortniteQuiz from '../../../img/quiz/fortnite-battle-royale-quiz.jpg';
import harryPotterQuiz from '../../../img/quiz/harry-potter-quiz.jpg';
import internetMemeQuiz from '../../../img/quiz/internet-meme-quiz.jpg';
import kurioseFaktenQuiz from '../../../img/quiz/kuriose-fakten-quiz.jpg';
import marvelSuperheldenQuiz from '../../../img/quiz/marvel-superhelden-quiz.jpg';
import pixarFilmquiz from '../../../img/quiz/pixar-filmquiz.jpg';
import skibidiToiletQuiz from '../../../img/quiz/skibidi-toilet-quiz.jpg';

export default function QuizSelectDialog({ 
  open, 
  onClose, 
  quizzes = [],
  onQuizSelect,
  selectedQuizId 
}) {
  const [searchTerm, setSearchTerm] = useState('');

  const getQuizImage = (quizId) => {
    switch (quizId) {
      case 'example-quiz': return exampleQuiz;
      case 'deutschland-quiz': return deutschlandQuiz;
      case 'fortnite-battle-royale-quiz': return fortniteQuiz;
      case 'harry-potter-quiz': return harryPotterQuiz;
      case 'internet-meme-quiz': return internetMemeQuiz;
      case 'kuriose-fakten-quiz': return kurioseFaktenQuiz;
      case 'marvel-superhelden-quiz': return marvelSuperheldenQuiz;
      case 'pixar-filmquiz': return pixarFilmquiz;
      case 'skibidi-toilet-quiz': return skibidiToiletQuiz;
      default: return null;
    }
  };

  const safeQuizzes = Array.isArray(quizzes) ? quizzes : [];

  const filteredQuizzes = safeQuizzes.filter(quiz => 
    (quiz?.title || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (quiz?.description || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (Array.isArray(quiz?.categories) ? quiz.categories : []).some(cat => 
      cat.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handleQuizSelect = (quiz) => {
    onQuizSelect(quiz);
    onClose();
  };

  const getDifficultyColor = (difficulty) => {
    switch ((difficulty || '').toLowerCase()) {
      case 'easy': return 'success';
      case 'medium': return 'warning';
      case 'hard': return 'error';
      default: return 'default';
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: 'glass',
        sx: { 
          background: 'rgba(28, 39, 60, 0.8)',
          backdropFilter: 'blur(10px)'
        }
      }}
    >
      <DialogTitle>
        Quiz auswählen
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Quiz suchen..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          size="small"
          sx={{ mt: 2 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      </DialogTitle>
      
      <DialogContent>
        <Grid container spacing={2}>
          {filteredQuizzes.map((quiz) => (
            <Grid item xs={12} sm={6} key={quiz.id}>
              <Card 
                className={quiz.id === selectedQuizId ? 'selected-quiz' : ''}
                sx={{ 
                  cursor: 'pointer',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  background: quiz.id === selectedQuizId 
                    ? 'rgba(203, 126, 0, 0.2)'
                    : 'rgba(255, 255, 255, 0.05)',
                  '&:hover': {
                    background: 'rgba(203, 126, 0, 0.1)'
                  }
                }}
                onClick={() => handleQuizSelect(quiz)}
              >
                {getQuizImage(quiz.id) && (
                  <CardMedia
                    component="img"
                    height="140"
                    image={getQuizImage(quiz.id)}
                    alt={quiz?.title || ''}
                  />
                )}
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    {quiz?.title || 'Unbenanntes Quiz'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {quiz?.description || 'Keine Beschreibung verfügbar'}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Chip 
                      label={quiz?.difficulty || 'Unbekannt'} 
                      size="small"
                      color={getDifficultyColor(quiz?.difficulty)}
                    />
                    {Array.isArray(quiz?.categories) && quiz.categories.map((category, index) => (
                      <Chip 
                        key={index}
                        label={category}
                        size="small"
                        variant="outlined"
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
      </DialogActions>
    </Dialog>
  );
} 